import { httpRequest } from './axios';
import { getCookie } from '../utils/cookie';

// 根据 hostname 判断环境对应的 feedback baseURL
function getFeedbackBaseURL() {
  const hostname = window.location.hostname;
  const hostMap = {
    'localhost': 'https://forum.developer-test.gp.qq.com',
    'developer-debug.gp.qq.com': 'https://forum.developer-debug.gp.qq.com',
    'developer-test.gp.qq.com': 'https://forum.developer-test.gp.qq.com',
    'developer-formaltest.gp.qq.com': 'https://forum.developer-formaltest.gp.qq.com',
    'developer-formalpre.gp.qq.com': 'https://forum.developer-formalpre.gp.qq.com',
    'developer.gp.qq.com': 'https://forum.developer.gp.qq.com',
  };
  return hostMap[hostname] || 'https://forum.developer.gp.qq.com';
}

const fetch = (serviceName) => {
  const env = process.env.BUILD_ENV;
  // if (env !== 'development' && !getCookie('oasisSessionId')) {
  //   location.href = `/resources/?oasisRedirectUrl=${encodeURIComponent(location.href)}`
  // }
  return (options) => {
    console.log('options',serviceName);
    return new Promise((resolve, reject) => {
      let url = `/${serviceName}?ts=${+ new Date()}`;
      // eslint-disable-next-line no-restricted-syntax
        
      if(serviceName == 'api/report'){
        httpRequest.post(url,JSON.stringify(options)).then(
            (response) => {
              if (typeof response === 'string' && response.indexOf('<title>绿洲开发者社区</title>') > -1) {
                // if (env !== 'development' && !getCookie('oasisSessionId')) {
                //   location.href = `/resources/?oasisRedirectUrl=${encodeURIComponent(location.href)}`
                // }
                reject('请求失败，请先登录')
              }
              resolve(response);
            },
            (err) => {
              console.log(err);
              reject('请求数据错误');
            },
          );
          return
      }
      if(serviceName == 'v3/feedback.create'){
        const baseUrl = getFeedbackBaseURL();
        console.log('feedbackCreate - baseUrl - ', baseUrl)
        const feedbackUrl = `${baseUrl}/api/v3/feedback.create?ts=${+ new Date()}`;
        const token = getCookie('oassis_access_token');
        httpRequest.post(feedbackUrl,JSON.stringify(options),{
          headers: { Authorization: token }
        }).then(
            (response) => {
              if (typeof response === 'string' && response.indexOf('<title>绿洲开发者社区</title>') > -1) {
                reject('请求失败，请先登录')
              }
              resolve(response);
            },
            (err) => {
              console.log(err);
              reject('请求数据错误');
            },
          );
          return
      }
      for (const key in options) {
        url += `&${key}=${options[key]}`;
      }
      console.log('url',url)
      httpRequest.get(url).then(
        (response) => {
          if (typeof response === 'string' && response.indexOf('<title>绿洲开发者社区</title>') > -1) {
            // if (env !== 'development' && !getCookie('oasisSessionId')) {
            //   location.href = `/resources/?oasisRedirectUrl=${encodeURIComponent(location.href)}`
            // }
            reject('请求失败，请先登录')
          }
          resolve(response);
        },
        (err) => {
          console.log(err);
          reject('请求数据错误');
        },
      );
    });
  };
};

export default function apiGenerator(apiConfig = {}) {
  const apis = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const key in apiConfig) {
    apis[key] = fetch(apiConfig[key]);
  }
  return apis;
}
